import { useEffect, useState } from "react";
import * as S from './styled';





export default function Repositories () {
    let [repositories, setRepositories] = useState([]);
    const [repNull, setRepNull] = useState(false);    

    useEffect(() => {
        let repositoriesName = localStorage.getItem('repositoriesName');        
        repositoriesName = JSON.parse(repositoriesName);
        setRepositories(repositoriesName);
        setRepNull(false);         
    }, []); 
    
    return(
        <S.Container>
            <S.Title>Repositórios</S.Title> 
            <S.List>
                { repositories.map((repository, index) => {
                    return(
                        <S.ListItem key={ index }>Repositório: { repository }</S.ListItem>
                    )
                }) }                
            </S.List>
            <S.LinkHome to="/">Voltar</S.LinkHome>
        </S.Container>
    )  
} 